export default "__VITE_ASSET__199bc8ea__"